<template>

    <!-- Ec breadcrumb start -->
    <div class="sticky-header-next-sec  ec-breadcrumb section-space-mb">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="row ec_breadcrumb_inner">
                        <div class="col-md-6 col-sm-12">
                            <h2 class="ec-breadcrumb-title">{{ $t('Blog') }}</h2>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <!-- ec-breadcrumb-list start -->
                            <ul class="ec-breadcrumb-list">
                                <li class="ec-breadcrumb-item"><router-link :to="{name: 'home', params: { lang : $i18n.locale }}" >{{ $t('Home') }}</router-link></li>
                                <li class="ec-breadcrumb-item active">{{ $t('Blog') }}</li>
                            </ul>
                            <!-- ec-breadcrumb-list end -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Ec breadcrumb end -->

    <!-- Ec Blog page -->
    <section class="ec-page-content section-space-p">
        <div class="container">
            <div class="row">
                <div class="ec-blogs-rightside col-lg-12 col-md-12">

                    <!-- Blog content Start -->
                    <div class="ec-blogs-content" v-if="items?.data?.length > 0">
                        <div class="ec-blogs-inner">
                            <div class="row">
                                <div class="col-lg-4 col-md-6 mb-6 ec-blog-block"
                                     v-for="item in items?.data" :key="item.id">
                                    <div class="ec-blog-inner">
                                        <div class="ec-blog-image">

                                            <router-link :to="{name: 'blog_posts.show', params: { id: item.id, lang : $i18n.locale }}">
                                                <img class="blog-image mw-100" :src="item.image"
                                                     :alt="item.title"
                                                     height="320"/>
                                            </router-link>

                                        </div>
                                        <div class="ec-blog-content">
                                            <h5 class="ec-blog-title">
                                                <router-link :to="{name: 'blog_posts.show', params: { id: item.id, lang : $i18n.locale  }}">
                                                    {{ item?.title }}
                                                </router-link>
                                            </h5>

                                            <div class="ec-blog-date">
                                                 <span>تاريخ المقال</span> {{ item.created_at }}
                                            </div>
<!--                                            <div class="ec-blog-desc">Lorem Ipsum is simply dummy text of the printing-->
<!--                                                and typesetting industry. Lorem Ipsum has been the industry's standard-->
<!--                                                dummy text ever since the 1500s,-->
<!--                                            </div>-->

                                            <div class="ec-blog-btn d-flex">
                                                <router-link :to="{name: 'blog_posts.show', params: { id: item.id, lang : $i18n.locale  }}"
                                                             class="btn btn-primary ms-auto">
                                                    قراءة المزيد
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <Bootstrap5Pagination
                            class="mb-0"
                            :data="items"
                            :limit="2"
                            :show-disabled="false"
                            :size="'default'"
                            :align="'center'"
                            @pagination-change-page="getResults"
                        />
                    </div>
                    <!--Blog content End -->
                    <div class="alert alert-info" v-else>
                        {{  $t('There are no articles here yet.') }}
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>

<script>

import {useToast} from "vue-toastification";

const toast = useToast();
import {Bootstrap5Pagination} from 'laravel-vue-pagination'

export default {
    components: {
        Bootstrap5Pagination
    },
    data() {
        return {
            items: [],
            q: this.$route.query,
        }
    },
    created() {
        this.getResults();
    },
    methods: {
        getResults(page = this.$route?.query?.page ?? 1) {

            const id = toast.info('Getting content ...', {icon: 'fa-solid fa-download'});

            axios.get('blog_posts', {
                params: {
                    'page': page,
                    'title': this.q.title,
                    'category_id': this.q.category_id,
                    'content': this.q.content
                }
            }).then(response => {
                toast.dismiss(id);
                this.items = response.data;
            }, response => {
                toast.dismiss(id);
            });

        },
    }
}
</script>
